import React from 'react';
import { Button, ButtonColor, ButtonSize, ButtonVariant, useShowContextRequired } from 'ui-builder';
import { Plan } from 'nekst-api';
import { InformationMessage, usePopupFormManager } from 'features/nekst-widgets';
import { CopyPlanForm } from 'features/tasks-forms';
import usePlansNavigator from '../plansNavigator';

import styles from './DefaultPlanHelper.module.scss';
import { PlanPermission, useAuthorizationChecker } from 'authorization-scope';

function CopyButton(
  props: {
    plan: Plan
  }
) {
  const popupFormManager = usePopupFormManager();

  const plansNavigator = usePlansNavigator()

  return (
    <Button
      text="Copy Workflow"
      onClick={() => {
        popupFormManager.openForm(<CopyPlanForm
          plan={props.plan}
          afterSubmitFunc={async (plan) => plansNavigator.openPlanPage(plan.id)}
        />)
      }}
      size={ButtonSize.MEDIUM}
      color={ButtonColor.BLUE}
      variant={ButtonVariant.FILLED}
    />
  )
}

export default function DefaultPlanHelper() {
  const showContext = useShowContextRequired<Plan>();

  const { isGranted } = useAuthorizationChecker();

  if (showContext.data.isGlobal && !isGranted(PlanPermission.UPDATE)) {
    return (
      <InformationMessage className={styles.box}>
        To Modify this Workflow, First Make a Copy
        {' '}
        <CopyButton plan={showContext.data} />
      </InformationMessage>
    );
  } else {
    return null;
  }
}
